/* eslint-disable max-lines-per-function */
import React from "react";
import {
  Grid,
  List,
  ListItemText,
  Switch,
  Typography,
  ListItemButton,
  ListItem,
} from "@mui/material";
import LimitInputs from "./limit-inputs";

type Props = {
  propertyId: string;
  isAdmin?: boolean;
  isSupervisor?: boolean;
}

const RentLimits: React.FC<Props> = ({
  isAdmin,
  isSupervisor,
}) => {
  if (!isAdmin && !isSupervisor) {
    return (
      <Grid container spacing={2}>
        <Typography variant="h5">
          Only Supervisors can make changes to Funding Sources
        </Typography>
      </Grid>
    );
  }

  const sidebarOptions = [
    { alias: "lhtc", label: "Tax Credit (LHTC)" },
    { alias: "hud", label: "HUD Based Rental Assistance" },
    { alias: "home", label: "HOME" },
    { alias: "ahtf", label: "Affordable Housing Trust Fund (AHTF)" },
  ];

  const incomeBrackets = [
    { alias: "thirty", label: "Extremely Low Income 30%" },
    { alias: "fifty", label: "Very Low Income 50%" },
    { alias: "eighty", label: "Low Income 80%" },
  ];

  const [checked, setChecked] = React.useState<number[]>([]);
  const [active, setActive] = React.useState(0);

  const handleToggle = (value: number) => () => {
    const currentIndex = checked.indexOf(value);
    const newChecked = [...checked];

    if (currentIndex === -1) {
      newChecked.push(value);
    } else {
      newChecked.splice(currentIndex, 1);
    }

    setChecked(newChecked);
  };

  const isActiveHOME = active === 2;

  return (
    <>
      <Grid container spacing={2}>
        <Grid size={{ xs: 12, md: 4, xl: 3 }}>
          <List>
            {sidebarOptions.map(({ label: value }, index) => {
              const labelId = `checkbox-list-secondary-label-${index}`;
              return (
                <ListItem key={`designation-${index}`}
                  secondaryAction={<Switch
                    edge="end"
                    onChange={handleToggle(index)}
                    checked={checked.indexOf(index) !== -1}
                    slotProps={{ input: { "aria-labelledby": labelId } }}
                  />}
                >
                  <ListItemButton
                    selected={index === active}
                    onClick={() => setActive(index)}
                  >
                    <ListItemText
                      id={labelId}
                      primary={value}
                      style={{ alignSelf: "flex-start" }}
                    />
                  </ListItemButton></ListItem>
              );
            })}
          </List>
        </Grid>

        <Grid size={{ xs: 12, md: 8, xl: 9 }}>
          {isActiveHOME && (
            <>
              <Typography variant="h6">HOME</Typography>
              <Typography variant="subtitle2">
                Choose HOME rent limits
              </Typography>
              <Grid container spacing={2}>
                {incomeBrackets.map(({ alias, label: bracket }, idx) => (
                  <LimitInputs
                    key={`bracket-${idx}`}
                    title={bracket}
                    alias={alias}
                  />
                ))}
              </Grid>
            </>
          )}
        </Grid>
      </Grid>
    </>
  );
};

export default RentLimits;
